import { useTranslation } from 'react-i18next';
import type { TradePerspective } from '~/graphql/graphql';

export function PerspectiveCaption({
  perspective,
}: {
  readonly perspective: TradePerspective;
}) {
  const { t } = useTranslation('general');
  return (
    <p data-testid="perspective-caption" className="text-sm text-neut-sec">
      {perspective === 'BUYING'
        ? t('perspective.buying')
        : t('perspective.selling')}
    </p>
  );
}
